import { ArrowDownAndRight } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import styled, { css } from 'styled-components';

import { typographyCss } from 'common/typography';

export const ItemRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemInfo = styled.div`
  border-block-end: 1px solid ${({ theme }) => theme.cbSemanticColors.borderPrimary};
  padding: 12px 0;
`;

export const ItemInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ItemCount = styled.div.attrs({ fontWeight: 'bold' })`
  ${typographyCss.Body3}
  display: flex;
`;

export const ItemName = styled.div`
  ${typographyCss.Body3}
  flex: 1;
  ${({ theme }) =>
    theme.cbDirection === 'ltr'
      ? css`
          padding-inline-end: 16px;
        `
      : css`
          padding-inline-start: 16px;
        `}
`;

export const ItemOptions = styled.div``;

export const ItemOption = styled.div`
  display: flex;
  border-block-end: 1px solid ${({ theme }) => theme.cbSemanticColors.borderPrimary};
  padding: 12px 0;
`;

export const ItemOptionCount = styled.div`
  ${typographyCss.Body3}
  display: flex;
  margin-inline-start: 36px;
  min-width: 36px;
  color: ${({ theme }) => theme.cbSemanticColors.textPrimary};
`;

export const ItemOptionValue = styled.div`
  ${typographyCss.Body3}
  flex: 1;
  ${({ theme }) =>
    theme.cbDirection === 'ltr'
      ? css`
          padding-inline-end: 16px;
        `
      : css`
          padding-inline-start: 16px;
        `}
  color: ${({ theme }) => theme.cbSemanticColors.textPrimary};
`;

export const ItemOptionPrice = styled.div`
  ${typographyCss.Body3}
  color: ${({ theme }) => theme.cbSemanticColors.textPrimary};
`;

export const PurchaseWeight = styled.div.attrs({ fontWeight: 'bold' })`
  ${typographyCss.Body3}
  display: flex;
  min-width: 36px;
`;

export const OriginalPurchaseWeight = styled.div`
  ${typographyCss.Body3}
  display: flex;
  /* ignore-color */
  color: ${colors.pepper64};
  text-decoration: line-through;
`;

export const SubstitutionItem = styled.div`
  ${typographyCss.Body3}
  display: flex;
  /* ignore-color */
  color: ${colors.pepper64};
`;

export const SubstitutionItemName = styled.span`
  ${typographyCss.Body3}
  display: flex;
  /* ignore-color */
  color: ${colors.pepper100};
  margin-inline-start: 4px;
`;

export const StyledArrowDownAndRight = styled(ArrowDownAndRight)`
  height: 14px;
  margin-inline-end: 6px;
  /* ignore-color */
  fill: ${colors.pepper64};
`;

export const MultiplicationSign = styled.div`
  ::before {
    content: '×';
    margin: 0 4px;
  }
`;

export const ItemPrice = styled.div`
  ${typographyCss.Body3}
`;
